"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var Segment_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Segment"));

var Header_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Segment/Header"));

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var StatNumber = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""])));
var Wrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  border: ", " solid ", ";\n  border-radius: ", ";\n"], ["\n  border: ", " solid ", ";\n  border-radius: ", ";\n"])), polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
}, polished_1.rem(5));
var PlayerWrapper = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: ", ";\n  padding: ", " 0;\n  color: ", ";\n  ", "\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: ", ";\n  padding: ", " 0;\n  color: ", ";\n  ", "\n"])), polished_1.rem(14), polished_1.rem(5), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
}, function (_a) {
  var top = _a.top;

  if (top) {
    return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n        font-weight: bold;\n        & > ", " {\n          font-size: ", ";\n        }\n      "], ["\n        font-weight: bold;\n        & > ", " {\n          font-size: ", ";\n        }\n      "])), StatNumber, polished_1.rem(16));
  }

  return styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject([""], [""])));
});
var Player = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject([""], [""])));
var PlayerClub = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: normal;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-weight: normal;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});

var PlayersLadder = function (_a) {
  var header = _a.header,
      statName = _a.statName,
      items = _a.items;
  return React.createElement(Wrapper, null, React.createElement(Segment_1["default"], {
    header: React.createElement(Header_1["default"], {
      withSeparator: true,
      size: "xs"
    }, header)
  }, items.map(function (i, idx) {
    return React.createElement(PlayerWrapper, {
      key: i._id,
      top: idx === 0
    }, React.createElement(Player, null, i.name, React.createElement("br", null), i.team && React.createElement(PlayerClub, null, i.team.name)), React.createElement(StatNumber, null, i.stats[statName]));
  })));
};

exports["default"] = PlayersLadder;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;